import { z } from 'zod';

export const accountTypeGetResponseSchema = z.object({
  data: z.object({ account_types: z.array(z.string()).optional(), value: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
